// extracted by mini-css-extract-plugin
export var container = "styles-module--container--23d41";
export var small = "styles-module--small--6b433";
export var widget = "styles-module--widget--eab8e";